import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import Container from '../../../components/Container';

import './style.scss';

const PartnersAll = (props) => {
  const { entities } = props;
  return (
    <div className="View PartnersAll">
      <Container small>
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'PartnersAll__item col col-6 col-sm-4 ';
            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  isActivePath
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default PartnersAll;
